export default "__VITE_ASSET__23dd5336__"